import React from 'react';
import useEducators from './useEducators';
import { REQUIRED_EDUCATOR_FIELDS } from '../../../../utils/user/REQUIRED_FIELDS';

export default function useActiveEducators(network, schoolStart, schoolEnd, currentTimestamp) {
  return useEducators(network, schoolStart, schoolEnd, {
    ...REQUIRED_EDUCATOR_FIELDS,
    inactive: false,
    $or: [
      {
        sleepingStartingAt: {
          $gte: currentTimestamp
        }
      },
      {
        sleepingEndingAt: {
          $lte: currentTimestamp
        }
      }
    ]
  });
}
